export default __webpack_public_path__ + "static/media/connect-bg_joshuamodlinger.69cd5801.webp";